import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=6788ed1f&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=6788ed1f&scoped=true&lang=less&"
import style1 from "./menus.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788ed1f",
  null
  
)

export default component.exports